import { connect } from 'react-redux';
import { anyPass } from 'ramda';

import PatientInfo from 'components/PatientInfo';
import { getUserProfileInfoForTechnician, getPatientName } from 'store/selectors/patientsData';
import { isTechnician } from 'store/selectors/user';

const mapStateToProps = (state, { id }) => ({
  isAvailableUserName: anyPass([isTechnician])(state),
  patientId: id,
  name: getPatientName(id)(state),
  info: getUserProfileInfoForTechnician(id)(state),
});

export default connect(mapStateToProps)(PatientInfo);
